import { createContext, useContext } from "react";
import type { SourceSlot } from "../sources/useSources.js";

export interface CompareController {
  /** The OTHER side of the diff, or null when not comparing. */
  readonly against: SourceSlot | null;
  /** Which side is "before" — false = live workspace is before. */
  readonly swapped: boolean;
  /** Convenience: comparing against something. */
  readonly inDiffMode: boolean;
  readonly setCompareAgainst: (slot: SourceSlot | null) => void;
  readonly swapCompare: () => void;
  readonly clearCompare: () => void;
}

export const CompareContext = createContext<CompareController | null>(null);

/** The composition's compare controller. Throws outside the provider. */
export function useCompare(): CompareController {
  const v = useContext(CompareContext);
  if (!v) {
    throw new Error("useCompare must be used within a <CompareProvider>");
  }
  return v;
}
